export const city = 'city';

export const userCity = 'user_city';

export const countryCode = 'country_code';

export const selectedCountryHintHidden = 'selected_country_hint_hidden';
